<template>
  <v-dialog v-model="openDialog" persistent max-width="510">
    <SmsAddContactToGroupForm
      :group="group"
      @selectionCompleted="handleSelection"
      @close="close"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import SmsAddContactToGroupForm from './SmsAddContactToGroupForm';

export default {
  name: 'SmsAddContactToGroupDialog',

  components: { SmsAddContactToGroupForm },

  data() {
    return {
      openDialog: false,
      group: {
        type: Object,
        default: () => {}
      }
    };
  },

  computed: {
    ...mapGetters('contactsV2', ['getContactById'])
  },

  created() {
    this.$root.$on('open-add-contact-to-group-dialog', this.open);
  },

  beforeDestroy() {
    this.$root.$off('open-add-contact-to-group-dialog');
  },

  methods: {
    ...mapActions('groupsV2', ['editUserGroup']),

    close() {
      this.group = {};
      this.openDialog = false;
    },

    handleSelection({ selection }) {
      const contacts = selection.map(id => this.getContactById(id).lean);
      const group = this.group.lean;
      this.editUserGroup({
        ...group,
        contacts: group.contacts.concat(contacts)
      }).finally(this.close);
    },

    open(group) {
      if (!group) return;

      this.group = group;
      this.openDialog = true;
    }
  }
};
</script>
